import {
  Component, Input, OnDestroy, OnInit
} from "@angular/core";
import {
  Subscription
} from "rxjs";
import {NgClassType} from "../../model/common.model";
import {StorageService} from "../../services/storage.service";


@Component({
  selector: 'component-base',
  template: ``
})
export abstract class ComponentBase implements OnInit, OnDestroy {

  @Input() debug = false
  @Input() uid?: string
  @Input() ngClass: NgClassType

  storageChangesSub?: Subscription

  protected constructor(
  ) {
  }

  ngOnDestroy(): void {
    this.unsubscribeStorageService()
  }

  ngOnInit(): void {
    this.subscribeStorageService()
  }


  ngNormalize(source: NgClassType) {
    const resultDictionary: { [id: string]: boolean } = {}
    if (typeof source === 'string') {
      resultDictionary[source] = true
      return resultDictionary
    }
    else if (Array.isArray(source)) {
      (source as string[]).forEach(classString => {
        resultDictionary[classString] = true
      })
      return resultDictionary
    }
    else {
      return Object.assign(resultDictionary, source)
    }
  }

  ngAssign(source: NgClassType, target: NgClassType): NgClassType{
    const lNormalize = this.ngNormalize(source)
    const rNormalize = this.ngNormalize(target)
    return Object.assign(lNormalize, rNormalize)
  }

  protected subscribeStorageService(): void {
    this.unsubscribeStorageService()
    this.debug = StorageService.sharedInstance.getItemJson('srs.debug') || false
    this.storageChangesSub = StorageService.sharedInstance.rawChanges.subscribe(
      (kv) => {
        if (kv.key === 'srs.debug') {
          this.debug = kv.value ? JSON.parse(kv.value) : false
          // console.warn('srs.debug changed', this.debug, 'kv',kv)
        }
      })
  }

  protected unsubscribeStorageService() {
    this.storageChangesSub?.unsubscribe()
    this.storageChangesSub = undefined
  }
}
